import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import Compiled, { LoadingMessage as CompiledLoadingMessage, menuCSS as compiledMenuCSS, MenuList as CompiledMenuList, menuListCSS as compiledMenuListCSS, MenuPlacer as CompiledMenuPlacer, MenuPortal as CompiledMenuPortal, menuPortalCSS as compiledMenuPortalCSS, NoOptionsMessage as CompiledNoOptionsMessage } from '../compiled/components/menu';

// Menu Component
// ------------------------------

export var menuCSS = function menuCSS(props) {
  return compiledMenuCSS();
};

// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MenuPlacer = function MenuPlacer(props) {
  return /*#__PURE__*/React.createElement(CompiledMenuPlacer, props);
};
var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement(Compiled, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Menu;

// ==============================
// Menu List
// ==============================

export var menuListCSS = function menuListCSS(props) {
  return compiledMenuListCSS();
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MenuList = function MenuList(props) {
  return /*#__PURE__*/React.createElement(CompiledMenuList, props);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref) {
  _objectDestructuringEmpty(_ref);
  return {
    textAlign: 'center',
    padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-150, 12px)")
  };
};
export var noOptionsMessageCSS = noticeCSS;
export var loadingMessageCSS = noticeCSS;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var NoOptionsMessage = function NoOptionsMessage(props) {
  return /*#__PURE__*/React.createElement(CompiledNoOptionsMessage, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var LoadingMessage = function LoadingMessage(props) {
  return /*#__PURE__*/React.createElement(CompiledLoadingMessage, props);
};

// ==============================
// Menu Portal
// ==============================

export var menuPortalCSS = function menuPortalCSS(props) {
  return compiledMenuPortalCSS();
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var MenuPortal = function MenuPortal(props) {
  return /*#__PURE__*/React.createElement(CompiledMenuPortal, props);
};